import { forwardRef, useState, useEffect, useCallback } from "react";
import { FaCity, FaHome, FaMapMarkerAlt, FaMapPin } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { useIntl } from "react-intl";
import axios from "axios";
import "../Dropdown.scss";
import "./SearchDropdown.scss";
import { getHost } from "../../../reducers/utils";
import { propertyFromArray, updateairlines } from "../../../utils";
import { suggestiontosearch } from "../../../reducers/api";
import { setSelectedDestination } from "../../../reducers/searchSlice";

// ✅ Stable empty references for useSelector fallbacks (prevents infinite re-renders)
const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

const SearchDropdown = forwardRef(({ onSelect, searchValue, onClose, selectedValue = [] }, ref) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const [loadedOptions, setLoadedOptions] = useState([]);
  const [geoDictionary, setGeoDictionary] = useState({});

  const regionGroups = useSelector((state) => state.properties?.regionGroups || EMPTY_ARRAY);

  const activeMode = useSelector((state) => state.search?.activeMode || EMPTY_OBJECT);
  const suggestions = useSelector((state) => state.properties?.suggestions || EMPTY_ARRAY);

  const filterAlreadySelected = (groups) => {
    if (selectedValue.length === 0) return groups;

    return groups.map((group) => ({
      ...group,
      options: group.options.map((option) => ({
        ...option,
        isSelected: selectedValue.some((selected) => selected.value === option.value && selected.label === option.label),
      })),
    }));
  };

  const loadOptions = useCallback(
    (destinationFilter) => {
      let destinationRegionGroups = [];
      let destinationRegions = [];
      let destinationCities = [];
      let destinationSuggestions = [];

      destinationRegions.sort((a, b) => a.Name?.toLocaleLowerCase().localeCompare(b.Name?.toLocaleLowerCase()));

      if (Array.isArray(suggestions) && suggestions.length > 0) {
        destinationSuggestions = [...suggestions];
      }

      // Apply search filter
      if (destinationFilter.length === 0) {
        destinationRegions = destinationRegions.filter((reg) => reg.RegionID !== undefined);
      } else {
        const filterLower = destinationFilter.toLowerCase();

        destinationRegionGroups = [];

        destinationRegions = [];

        destinationCities = [];

        destinationSuggestions = [];
      }

      let groups = [];

      // RegionGroups come first (in original order of importance)
      if (destinationRegionGroups.length > 0) {
        groups.push({
          label: intl.formatMessage({ id: "travelGroups" }),
          options: destinationRegionGroups,
        });
      }

      if (destinationSuggestions.length > 0) {
        groups.push({
          label: intl.formatMessage({ id: "ourRecommendations" }),
          options: destinationSuggestions,
        });
      }

      if (destinationRegions.length > 0) {
        groups.push({
          label: intl.formatMessage({ id: "regions" }),
          options: destinationRegions,
        });
      }

      if (destinationCities.length > 0) {
        groups.push({
          label: intl.formatMessage({ id: "resorts" }),
          options: destinationCities,
        });
      }

      if (destinationFilter.length > 3) {
        setIsLoading(true);
        axios
          .get(getHost() + "/namesearch?query=" + encodeURIComponent(destinationFilter))
          .then((response) => {
            setIsLoading(false);
            let destinationHotels = [];
            //setGeoDictionary(response.data.GeoDictionary || {});

            if (response.data.matches && Array.isArray(response.data.matches)) {
              for (let i = 0; i < response.data.matches.length; i++) {
                let suggest = response.data.matches[i];

                let obj = {};
                if (suggest.type == "Village") {
                  obj.label = suggest.name;
                  obj.Name = suggest.name;
                  obj.value = suggest.name;
                  obj.CityID = suggest.id * 1;
                }

                if (suggest.type == "Region") {
                  obj.label = suggest.name;
                  obj.Name = suggest.name;
                  obj.value = suggest.name;
                  obj.RegionID = suggest.id * 1;
                }

                if (suggest.type == "Accommodation") {
                  obj.label = suggest.name;
                  obj.Name = suggest.name;
                  obj.value = suggest.name;
                  obj.HotelID = suggest.id * 1;
                }

                if (suggest.type == "Destination") {
                  obj.label = suggest.name;
                  obj.Name = suggest.name;
                  obj.value = suggest.name;
                  obj.RegionID = suggest.id * 1;
                }

                destinationHotels.push(obj);
              }
            }

            if (destinationHotels.length > 0) {
              groups.push({
                label: intl.formatMessage({
                  id: "results",
                  defaultMessage: "Ergebnisse",
                }),
                options: destinationHotels,
              });
            }

            groups = filterAlreadySelected(groups);
            setLoadedOptions(groups);
          })
          .catch((error) => {
            console.error("Error loading hotels:", error);
            groups = filterAlreadySelected(groups);
            setLoadedOptions(groups);
            setIsLoading(false);
          });
      } else {
        groups = filterAlreadySelected(groups);
        setLoadedOptions(groups);
      }
    },
    [regionGroups, suggestions, activeMode, selectedValue, intl],
  );

  useEffect(() => {
    if (regionGroups.length > 0) {
      setIsLoading(false);
      loadOptions(searchValue || "");
    } else {
      setIsLoading(true);
    }
  }, [regionGroups, searchValue]); // loadOptions entfernt um Loop zu vermeiden

  const handleSelect = async (option) => {
    let theSelection = [option];

    if (theSelection[0].RegionGroupID) delete theSelection[0].Region;
    if (theSelection[0].RegionID) delete theSelection[0].City;

    if (option.type === "suggestion") {
      suggestiontosearch(option, dispatch);
      try {
        /* const originalPromiseResult = await getFilters(dispatch, false).then(
            unwrapResult
          );
          updateairlines(
            dispatch,
            airlines,
            originalPromiseResult,
            airlinerank,
            nolowcost,
            linie
          );*/
      } catch (error) {
        console.error("Error updating filters:", error);
      }
    } else {
      //dispatch(setSelectedDestination(theSelection));
      try {
        /*const originalPromiseResult = await getFilters(dispatch, false).then(
            unwrapResult
          );
          updateairlines(
            dispatch,
            airlines,
            originalPromiseResult,
            airlinerank,
            nolowcost,
            linie
          );*/
      } catch (error) {
        console.error("Error updating filters:", error);
      }
    }

    // dispatch(setSearchOption({ property: "destinationStations", data: [] }));

    if (onSelect) {
      onSelect(theSelection, option);
    }
  };

  const formatOptionLabel = (opt) => {
    return (
      <div className="option-content">
        <div className="option-icon-wrapper">
          {opt.type === "suggestion" ? (
            <FaMapPin className="option-icon" />
          ) : opt.RegionGroupID ? (
            <FaMapPin className="option-icon" />
          ) : opt.RegionID ? (
            <FaMapMarkerAlt className="option-icon" />
          ) : opt.CityID ? (
            <FaCity className="option-icon" />
          ) : (
            <FaHome className="option-icon" />
          )}
        </div>
        <div className="option-details">
          <span className="option-title">{opt.label}</span>
          <div className="option-subtitle">
            {opt.HotelCodes && geoDictionary?.Cities && (
              <span>
                {propertyFromArray(geoDictionary.Cities.City || [], opt.HotelLocationRef?.CityID, "CityID", "Name")}
                {", "}
              </span>
            )}
            {opt.HotelCodes && geoDictionary?.Countries && <span>{propertyFromArray(geoDictionary.Countries.Country || [], opt.HotelLocationRef?.CountryCode, "CountryCode", "Name")}</span>}
            {opt.HotelCount && (
              <span>
                {" "}
                ({opt.HotelCount} {intl.formatMessage({ id: "hotels" })})
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const isSelected = (option) => {
    return selectedValue.some((item) => item.value === option.value && item.label === option.label);
  };

  if (isLoading && loadedOptions.length === 0) {
    return (
      <div className="main_input-dropdown" ref={ref}>
        <div className="dropdown-loading">{intl.formatMessage({ id: "loading" })}</div>
      </div>
    );
  }

  return (
    <div className="main_input-dropdown" ref={ref}>
      <div className="dropdown-header">
        <span className="dropdown-title">{intl.formatMessage({ id: "chooseDestination" })}</span>
      </div>

      {loadedOptions.map((group, groupIndex) => (
        <div key={groupIndex} className="dropdown-section">
          <h4>{group.label}</h4>
          <div className="dropdown-options">
            {group.options.map((option, optionIndex) => (
              <div key={`${groupIndex}-${optionIndex}`} className={`dropdown-option ${isSelected(option) ? "selected" : ""}`} onClick={() => handleSelect(option)}>
                {formatOptionLabel(option)}
              </div>
            ))}
          </div>
        </div>
      ))}

      {loadedOptions.length === 0 && !isLoading && (
        <div className="dropdown-section">
          <div className="dropdown-empty">{intl.formatMessage({ id: "noResultsFound" })}</div>
        </div>
      )}
    </div>
  );
});

export default SearchDropdown;
